<template>
  <div class="editor-popup">
    <div class="editor-popup__content">
      <div class="editor-popup__close" @click="close" />

      <div class="editor-popup__content-type">
        <h3 class="editor-popup__title editor-popup__title--marker">
          <img :src="`${newMark.image}`" class="mark__image" />
          Add marker
        </h3>
      </div>
      <div class="editor-popup__mark-type">
        <span
          @click="selectMarkType('content')"
          :class="`tab ${type === 'content' ? 'selected' : ''}`"
        >Content</span> /
        <span
          @click="selectMarkType('navigation')"
          :class="`tab ${type === 'navigation' ? 'selected' : ''}`"
        >Navigation</span>
      </div>
      <div v-if="type === 'content'">
        <div class="field">
          <label class="label">Text (EN)</label>
          <input class="input input--outline" placeholder="_" v-model="label.en" />
        </div>
        <div class="field">
          <label class="label">Link (EN)</label>
          <input class="input input--outline" placeholder="_" v-model="link.en" />
        </div>
        <div class="field">
          <label class="label">Text (DE)</label>
          <input class="input input--outline" placeholder="_" v-model="label.de" />
        </div>
        <div class="field">
          <label class="label">Link (DE)</label>
          <input class="input input--outline" placeholder="_" v-model="link.de" />
        </div>
      </div>
      <div v-else>
        <div class="field">
          <label class="label">Text (EN)</label>
          <input class="input input--outline" placeholder="_" v-model="label.en" />
        </div>
        <div class="field">
          <label class="label">Text (DE)</label>
          <input class="input input--outline" placeholder="_" v-model="label.de" />
        </div>
        <div class="field">
          <label class="label">Select subscene</label>
          <select class="input input--outline" @change="handleChangeNavigation($event)">
            <option
              v-for="subscene in subscenes"
              :value="subscene._id"
              :key="subscene._id"
            >{{subscene.name}}</option>
          </select>
        </div>
      </div>
      <br />
      <button class="button button--info button--mr-20" @click="add">Add</button>
      <button class="button" @click="close">Close</button>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

import { getProjectScenes } from "../../../utils";

export default {
  data() {
    return {
      type: "content",
      navigation: "",
      label: {
        en: "",
        de: ""
      },
      link: {
        en: "",
        de: ""
      }
    };
  },
  mounted() {
    this.navigation = this.subscenes.length ? this.subscenes[0]._id : "";
  },
  computed: {
    ...mapState([
      "newMark",
      "selectedScene",
      "selectedProject",
      "unsavedScenes"
    ]),
    subscenes() {
      return getProjectScenes(this.selectedProject).filter(
        s => s.type === "subscene"
      );
    }
  },
  methods: {
    ...mapMutations([
      "addMark",
      "closePopup",
      "saveLocalScene",
      "addUnsavedScene",
      "openSidebar"
    ]),
    handleChangeNavigation(event) {
      this.navigation = event.currentTarget.value;
    },
    add() {
      const index = this.unsavedScenes
        .map(s => s._id)
        .indexOf(this.selectedScene._id);


      this.addMark({
        index,
        marker: {
          handleNext:
            this.navigation.length && this.type === "navigation"
              ? this.navigation
              : null,
          label: this.label,
          link: this.type === "content" ? this.link : null
        }
      });

      this.saveLocalScene(this.selectedScene);
      this.addUnsavedScene(this.selectedScene);

      this.openSidebar("markers");
    },
    close() {
      this.closePopup("addMark");
    },
    selectMarkType(type) {
      this.type = type;
    }
  }
};
</script>

<style lang="scss" scoped>
.button--mr-20 {
  margin-right: 20px;
}

.editor-popup__mark-type {
  display: flex;
  justify-content: center;
}

.tab {
  color: #333;
  cursor: pointer;
  margin: 0 10px 40px;
  user-select: none;

  &.selected {
    color: #00bfff;
  }
}
</style>
